import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { style: {"font-size":"64px"} }
const _hoisted_2 = { class: "timeline-container" }
const _hoisted_3 = { class: "timeline-left" }
const _hoisted_4 = { class: "timeline-dot-container" }
const _hoisted_5 = {
  key: 0,
  class: "timeline-line"
}
const _hoisted_6 = { class: "timeline-right" }
const _hoisted_7 = { class: "timeline-content" }
const _hoisted_8 = { class: "content-text" }
const _hoisted_9 = { class: "content-address" }
const _hoisted_10 = { class: "timeline-time" }
const _hoisted_11 = {
  key: 0,
  class: "no-data"
}

import { ConfigService } from "@/api/services/ConfigService";
import { onMounted, PropType, reactive, ref } from "vue";
import { DeliveryRequest } from "@/api/models/config/DeliveryRequest";
import { message } from "ant-design-vue";
import { Response } from "@/api/models/config/DeliveryResponse";
import { UserOutlined } from "@ant-design/icons-vue";
import dayjs from "dayjs";


export default /*@__PURE__*/_defineComponent({
  __name: 'DeliveryView',
  props: {
  accept: {
    type: Object as PropType<DeliveryRequest>,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const formatDate = (date: string) => {
  return dayjs(date).format("YYYY-MM-DD HH:mm:ss");
};

const data = reactive<Response>({
  showapi_res_error: "",
  showapi_fee_num: 0,
  showapi_res_code: 0,
  showapi_res_id: "",
  showapi_res_body: {
    delivery_time: "",
    nu: "",
    logo: "",
    original_com: "",
    com: "",
    tel: "",
    data: [],
    msg: "",
    possible_exp_list: [],
    ret_code: 0,
    update_time: "",
    showapi_inner_fee_num: 0,
    query_num: 0,
    com_name: "",
    delivery_address_details: {
      address: "",
      location: "",
    },
  },
});

const loading = ref(true);

const handleDelivery = async () => {
  try {
    const res = await ConfigService.Delivery(props.accept);
    if (res.code === 0) {
      Object.assign(data, res.data);
    } else {
      message.error(res.msg);
    }
  } catch (error) {
    message.error("请求失败，请稍后重试");
  } finally {
    loading.value = false;
  }
};

onMounted(() => {
  handleDelivery();
});

return (_ctx: any,_cache: any) => {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!

  return (loading.value)
    ? (_openBlock(), _createBlock(_component_a_spin, {
        key: 0,
        size: "large"
      }))
    : (_openBlock(), _createBlock(_component_a_card, {
        key: 1,
        bordered: false
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_row, { gutter: 16 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_card, { bordered: false }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, { span: 4 }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_1, [
                                (
                    data.showapi_res_body?.logo === undefined ||
                    data.showapi_res_body?.logo === ''
                  )
                                  ? (_openBlock(), _createBlock(_unref(UserOutlined), { key: 0 }))
                                  : (_openBlock(), _createBlock(_component_a_image, {
                                      key: 1,
                                      src: data.showapi_res_body?.logo,
                                      size: 64
                                    }, null, 8, ["src"]))
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 20 }, {
                            default: _withCtx(() => [
                              _createElementVNode("h2", null, _toDisplayString(data.showapi_res_body?.com_name || "未知快递公司"), 1),
                              _createElementVNode("p", null, "快递单号：" + _toDisplayString(data.showapi_res_body?.nu || "未知单号"), 1),
                              _createElementVNode("p", null, "联系电话：" + _toDisplayString(data.showapi_res_body?.tel || "未知电话"), 1),
                              _createElementVNode("p", null, " 预计送达时间：" + _toDisplayString(data.showapi_res_body?.delivery_time || "未知时间"), 1),
                              _createElementVNode("p", null, " 更新时间：" + _toDisplayString(data.showapi_res_body?.update_time || "未知时间"), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, {
                span: 24,
                style: {"margin-top":"8px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_card, {
                    title: "物流进度",
                    bordered: false
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.showapi_res_body.data, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: _normalizeClass(["timeline-item", { 'is-first': index === 0 }])
                          }, [
                            _createElementVNode("div", _hoisted_3, [
                              _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["timeline-dot", { active: index === 0 }])
                                }, null, 2),
                                (index !== data.showapi_res_body.data.length - 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, _toDisplayString(item.context), 1),
                                _createElementVNode("div", _hoisted_9, _toDisplayString(item.address), 1)
                              ]),
                              _createElementVNode("div", _hoisted_10, _toDisplayString(formatDate(item.time)), 1)
                            ])
                          ], 2))
                        }), 128)),
                        (!data.showapi_res_body?.data?.length)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_11, " 暂无物流信息 "))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, {
                span: 24,
                style: {"margin-top":"8px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_card, {
                    title: "收货地址",
                    bordered: false
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, _toDisplayString(data.showapi_res_body?.delivery_address_details?.address ||
              "未知地址"), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
}
}

})